import React, { useState, useEffect, Fragment } from 'react';

// Analytics
import mixpanel from 'mixpanel-browser';

// Components
import Refund_Policy from '../components/policies/Refund_Policy';
import Cancellation_Policy from '../components/policies/Cancellation_Policy';
import Subscription_Details from '../components/policies/Subscription_Details';
import Terms from '../components/policies/Terms';

const Policies = () =>  {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Analytics 
  const [sentMixpanel, setSentMixpanel] = useState(false);
  
  useEffect(() => {
      
      // Add event listener for window resize
      window.addEventListener('resize', () => handleWindowSizeChange());

      // Cleanup the event listener when the component unmounts
      return () => window.removeEventListener('resize', () => handleWindowSizeChange());
  }, []);

  // scroll to section on page load if '#' is detected in URL
    useEffect(() => {
      const hash = window.location.hash; // Get hash from URL
      if (hash) {
          const element = document.getElementById(hash.substring(1)); // Remove "#" from hash
          if (element) {
              element.scrollIntoView({ behavior: "smooth" });
          }
      }
    }, []); 

  // Update window width state on window resize
  const handleWindowSizeChange = () => {
      setWindowWidth(window.innerWidth);
  };

  // Check if the device is mobile or tablet
  const isMobile = windowWidth <= 769;
  const isTablet = windowWidth <= 1024;

  // Function to handle Mixpanel analytics
  const handleMixpanel = () => {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
    mixpanel.track("Policies Page View");
  }

  // Trigger Mixpanel analytics on initial render in production mode
  if(process.env.NODE_ENV === 'production' && !sentMixpanel) {
      handleMixpanel();
      setSentMixpanel(true);
  }

	return (
        <main style={{padding: '2rem .5rem', maxWidth: '48rem', margin: '0 auto', width: '100%'}}>
            <h1 style={{fontWeight: 'bold', fontSize: '2.25rem', lineHeight: '2.5rem', textAlign: 'center', margin: '0 0 3rem'}}>
                Our Policies
            </h1>
            <Refund_Policy isMobile={isMobile} />
            {/* Spacer */}
            <div id="cancel-policy" style={{height: '2rem'}} />
            <Cancellation_Policy is_policy_page isMobile={isMobile} />
            {/* Spacer */}
            <div id="subscription" style={{height: '2rem'}} />
            <Subscription_Details isMobile={isMobile} />
            {/* Spacer */}
            <div id="terms" style={{height: '2rem'}} />
            <Terms isMobile={isMobile} />
        </main>
	);
  }
  

export default Policies;
  
  